(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("OCS", [], factory);
	else if(typeof exports === 'object')
		exports["OCS"] = factory();
	else
		root["OCS"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(1);

	var _assign = __webpack_require__(5);

	var _assign2 = _interopRequireDefault(_assign);

	__webpack_require__(41);

	var _im = __webpack_require__(42);

	var _im2 = _interopRequireDefault(_im);

	var _util = __webpack_require__(45);

	var _util2 = _interopRequireDefault(_util);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Description: 会员端使用的 SDK，继承自 im，额外包含了分配、恢复会话等接口
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: 常胤 <satans17@gmail.com>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 15/3/30
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright(c) 2014 Taobao.com
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

	module.exports = function (_IM) {
	  _inherits(OCS, _IM);

	  function OCS(config) {
	    _classCallCheck(this, OCS);

	    /**
	     * @private 心跳
	     * @type {null}
	     * @private
	     */
	    var _this = _possibleConstructorReturn(this, _IM.call(this, config));

	    _this._keepAliveTimer = null;
	    _this._message();
	    return _this;
	  }

	  /**
	   * 心跳
	   * @private
	   */


	  OCS.prototype._keepAlive = function _keepAlive() {
	    var _this2 = this;

	    var timer = function timer() {
	      _this2._request("keepAlive", {
	        userType: _this2.userType
	      }).then(function (resp) {
	        _this2.log('keep alive success');
	        // 更新消息必达功能的开关状态
	        _this2._isDeliveredOn = +(resp.delivered || 0);
	        // 更新已读未读功能的开关状态
	        _this2._isReadStatusOn = +(resp.supportNewFunction || 0);
	      }, function () {
	        _this2.log('keep alive fail');
	      });
	      _this2._keepAliveTimer = setTimeout(timer, 15000);
	    };

	    this._keepAliveTimer = setTimeout(timer, 15000);
	  };

	  /**
	   * 内部处理一些消息
	   * @private
	   */


	  OCS.prototype._message = function _message() {
	    var _this3 = this;

	    this.on('message', function (data) {
	      if (data && data.length > 0) {
	        data.forEach(function (item) {

	          //用户离线
	          if (item.cmd === 'UserLeave') {
	            _this3.__userLeave(item);
	          }

	          //客服加入
	          if (item.cmd === 'UserJoin') {
	            _this3.__userJoin(item);
	          }

	          // 针对“已读未读”功能；会员 resume 成功后，小二会收到此类型消息，来更新 supportNewFunction 的开关状态
	          if (item.cmd === 'MESSAGE_UNREAD') {
	            _this3._isReadStatusOn = +item.head.supportNewFunction;
	          }
	        });
	      }
	    });
	  };

	  /**
	   * 加入会话消息
	   * @param data
	   * @private
	   */


	  OCS.prototype.__userJoin = function __userJoin(data) {
	    if (data && data.head && data.head.tenantId) {
	      // 代码执行到此处，data.head 必定不为空
	      var _data$head = data.head,
	          _data$head$tenantId = _data$head.tenantId,
	          tenantId = _data$head$tenantId === undefined ? this.tenantId : _data$head$tenantId,
	          _data$head$department = _data$head.departmentId,
	          departmentId = _data$head$department === undefined ? this.departmentId : _data$head$department;

	      // 如果是跨 BU 转交则 UserLeave MSG 将含有转交到的 tenantId，并且如果路由或路由版本有变更则替换本地的

	      this.tenantId = tenantId;
	      this.departmentId = departmentId;
	      //更新SDK通用参数中的tenantId
	      this._commonParams.tenantId = this.tenantId;
	      //更新SDK通用参数中的tenantId
	      this._commonParams.xsp_tenantid = this.tenantId;
	      this._commonParams.xsp_departmentid = this.departmentId;
	    }

	    if (data && data.head && data.head.switchMemo) {
	      this.emit('UserSwitch', {
	        data: data,
	        type: 'join',
	        message: '新客服加入'
	      });
	    } else {
	      this.emit('UserJoin', {
	        data: data
	      });
	    }
	  };

	  /**
	   * 会员端使用
	   *
	   * step1:登录鉴权
	   * 因“异地多活”，此处需要请求 auth/login.do 接口，以获取 tenantId 并初始化路由
	   *
	   * @param config {Object}
	   * @returns {Promise}
	   */


	  OCS.prototype.login = function login(config) {
	    var _this4 = this;

	    return this._loginForInterface(config).then(function (data) {
	      _this4.emit('login', data);
	      return data;
	    }, function (err) {
	      throw err;
	    });
	  };

	  /**
	   * step2: 恢复会话
	   */


	  OCS.prototype.resume = function resume() {
	    var _this5 = this;

	    return this._request("resume", { supportNewFunction: this._isReadStatusOn }).then(function (data) {
	      // isContinue 表示需要直连之前的小二
	      if (data.isInQueue || data.isServicing || data.isContinue) {

	        //启动消息轮询
	        _this5._startSession(data);

	        return data;
	      } else {
	        throw new Error('resume fail');
	      }
	    }, function (err) {
	      throw err;
	    });
	  };

	  /**
	   * 分配客服
	   * @returns {*}
	   */


	  OCS.prototype.dispatch = function dispatch(data) {
	    var _this6 = this;

	    // dispatch 接口需要这两个参数
	    if (!data.userId || !data.userName) {
	      data.userId = this.userId;
	      data.userName = this.userName;
	    }

	    //解决IE浏览器乱码的问题
	    if (data.question) {
	      data.question = encodeURIComponent(data.question);
	    }

	    // 已读未读功能
	    data.supportNewFunction = this._isReadStatusOn;

	    return this._request("dispatch", data).then(function (data) {
	      //启动消息轮询
	      _this6._startSession(data);
	      return data;
	    }, function (err) {
	      throw err;
	      //2003:没有客服上班
	      //2004:开启会话失败
	      //3005:会话中
	    });
	  };

	  /**
	   * 重新IM.start()方法
	   */


	  OCS.prototype.start = function start() {
	    throw new Error('Please call login method');
	  };

	  OCS.prototype._startSession = function _startSession(data) {
	    this.addCommonParams('token', data.token);
	    this.sid = data.sid;
	    this.token = data.token;
	    this._keepAlive();
	    this._loopStart({
	      token: this.token
	    });
	  };

	  /**
	   * 关闭会话，不调用memberleave接口
	   * @private
	   */


	  OCS.prototype._closeSession = function _closeSession() {
	    //关闭轮询
	    this.close();

	    //关闭心跳
	    if (this._keepAliveTimer) {
	      clearTimeout(this._keepAliveTimer);
	    }
	  };

	  /**
	   * 获取技能组排队人数
	   * @param queueId
	   */


	  OCS.prototype.getQueueNumber = function getQueueNumber(queueId) {
	    return this._request("getQueueNumber", {
	      queueId: queueId
	    }).then(function (data) {
	      return data.waitingNum;
	    }, function (err) {
	      throw err;
	    });
	  };

	  /**
	   * 会员离开会话
	   * @param leaveType
	   * @param leaveReason
	   */


	  OCS.prototype.memberLeave = function memberLeave(leaveType, leaveReason) {
	    return this._request("memberLeave", {
	      leaveType: leaveType,
	      leaveReason: leaveReason
	    }).then(function (data) {
	      return data;
	    }, function (err) {
	      throw err;
	    });
	  };

	  /**
	   * 校验埋点是否可用
	   */


	  OCS.prototype.checkOcsSource = function checkOcsSource() {
	    return this._request("checkOcsSource", {
	      sourceId: this.sourceId
	    }).then(function (data) {
	      return data;
	    }, function (err) {
	      throw err;
	    });
	  };

	  /**
	   * 获取排队消息通知
	   * @param queueId
	   */


	  OCS.prototype.getOcsQueueNotice = function getOcsQueueNotice(queueId) {
	    return this._request("getOcsQueueNotice", {
	      queueId: queueId
	    }).then(function (data) {
	      return data;
	    }, function (err) {
	      throw err;
	    });
	  };

	  /**
	   * 获取埋点的详情信息
	   * @param sourceId
	   */


	  OCS.prototype.getSourceIdConfigDetail = function getSourceIdConfigDetail(sourceId) {
	    return this._request("getSourceIdConfigDetail", {
	      sourceId: sourceId
	    }).then(function (data) {
	      return data;
	    }, function (err) {
	      throw err;
	    });
	  };

	  /**
	   * 发送文本消息
	   * @param type {String | Object}  类型；如果是对象，则忽略后面的参数
	   * @param body {String} 内容
	   * @returns {Promise}
	   */


	  OCS.prototype.sendMessage = function sendMessage(type, body) {
	    var _this7 = this;

	    var needFirstRetry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	    var lastResendTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Date();

	    var params = {
	      sid: this.sid,
	      userId: this.userId,
	      senderId: this.userId,
	      senderName: this.userName,
	      // 默认客户端发送，会员 1，客服 2，其他 3
	      senderType: this.userType,
	      // 解决客户端GBK编码乱码的问题
	      body: encodeURIComponent(body),
	      type: type
	    };
	    // “设置消息已读”也使用这个接口
	    if (type === 'MESSAGE_READ_CONFIRM') {
	      params.body = '';
	      params.mids = body;
	    }

	    // 如果只传了一个对象为参数，那么忽略其他参数
	    if (Object.prototype.toString.call(type) === '[object Object]') {
	      params.type = type.type;
	      params.body = encodeURIComponent(type.body);

	      // 图片消息
	      if (type.subType === 'image') params.imgTag = 'imageTag';
	      // 会员端在某些特殊情况下，可以指定 senderType（目前支持 3）
	      if (type.senderType) params.senderType = type.senderType;
	    }

	    return this._request('send', params)
	    // 接口返回的 mid 是 long 型，msgId 才是 str 型
	    .then(function (data) {
	      return { mid: data.msgId };
	    }, function (err) {
	      // 用户不在会话中
	      if (err.code == 13) {
	        throw err;
	        return;
	      }

	      //发送消息失败，则重新发送
	      if (err.code == -1) {
	        return _this7._resend(lastResendTime, type, body);
	      }

	      //如果首次调用发送消息且不是业务接口引起的失败，将支持首次发送失败消息重发。
	      console.log('send message failed, retry it', needFirstRetry);
	      if (needFirstRetry) {
	        return _this7.sendMessage(type, body, false);
	      }

	      //消息发送失败则Report消息失败
	      var url = _util2["default"].param(_this7._getURL('send'), _this7._mergeCommonParams(params));
	      _this7._request('reportHttpRequestIssue', {
	        requestUrl: _util2["default"].encode(url),
	        responseError: 'OCS_SEND_MSG_FAILED'
	      });

	      throw err;
	    });
	  };

	  /**
	   * 设置消息已读
	   *
	   * @param mids {Array} mid 数组
	   *
	   */


	  OCS.prototype.setReadStatus = function setReadStatus() {
	    var mids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	    if (!mids.length) return Promise.resolve('消息 ID 为空');
	    return this.sendMessage('MESSAGE_READ_CONFIRM', mids);
	  };

	  /**
	   * 发送系统消息（例如，小二输入时，向会员端发送“正在输入”的预览消息）
	   *
	   * @param {Object} data
	   *
	   * @return {Promise}
	   */


	  OCS.prototype.sendSystemMessage = function sendSystemMessage(data) {
	    return this._request('ocsSystemMessage', data, {
	      param: 'callbackName',
	      name: 'OcsSendSystemMessageCallback'
	    });
	  };

	  /**
	   * 退出云客服
	   * @param leaveType
	   * @param leaveReason
	   * @returns {*}
	   */


	  OCS.prototype.logout = function logout(leaveType, leaveReason) {
	    var self = this;
	    var _logout = function _logout() {
	      self.__userLeave({
	        cmd: 'UserLeave',
	        head: {
	          leaveType: 'servicerLeave',
	          //业务上标示为主动退出
	          closeReasonType: 2,
	          closeReasonDetail: 10
	        }
	      });
	    };

	    //主要主动调用logout,不论结果如何,都强制退出云客服逻辑
	    return this._request("memberLeave", {
	      sid: this.sid,
	      token: this.token,
	      userName: this.userName,
	      leaveType: leaveType,
	      leaveReason: leaveReason
	    }).then(function () {
	      _logout();
	    }, function (err) {
	      _logout();
	    })["catch"](function (err) {
	      _logout();
	    });
	  };

	  /**
	   * 用户离线处理逻辑
	   * @param data
	   * @private
	   */


	  OCS.prototype.__userLeave = function __userLeave(data) {
	    var msg = void 0,
	        type = void 0,
	        leaveType = void 0;

	    //20160427 @云田 梳理了退出逻辑
	    if (data && data.head && (leaveType = data.head.leaveType)) {
	      switch (leaveType) {
	        case "memberForceLeave":
	          msg = '您已在其他地方登录';
	          type = 1;
	          break;
	        case "heartCheckTimeout":
	          msg = '会话心跳超时';
	          type = 5;
	          break;
	        case "servicerLeave":
	          msg = '会员/客服主动关闭会话';
	          type = 2;
	          break;
	        case "isSwitch":
	          msg = '您被转交给其他客服';
	          type = 3;
	          break;
	        case "memberLeave":
	          msg = '会员主动退出';
	          type = 4;
	        default:
	          msg = '异常退出';
	          type = -2;
	      }
	    } else {
	      msg = '异常退出';
	      type = -1;
	    }

	    if (type === 3) {
	      // 代码执行到此处，data.head 必定不为空
	      var _data$head2 = data.head,
	          _data$head2$newSid = _data$head2.newSid,
	          newSid = _data$head2$newSid === undefined ? this.sid : _data$head2$newSid,
	          _data$head2$tenantId = _data$head2.tenantId,
	          tenantId = _data$head2$tenantId === undefined ? this.tenantId : _data$head2$tenantId,
	          _data$head2$departmen = _data$head2.departmentId,
	          departmentId = _data$head2$departmen === undefined ? this.departmentId : _data$head2$departmen;

	      // 转交后如果 UserLeave MSG 的 head 里含有转交后生产的 sid 则替换本地的 sid

	      if (this.sid !== newSid) {
	        this.sid = newSid;
	      }

	      // 如果是跨 BU 转交则 UserLeave MSG 将含有转交到的 tenantId，并且如果路由或路由版本有变更则替换本地的
	      if (this.tenantId !== tenantId) {
	        this.tenantId = tenantId;
	        //跨BU转交后，更新SDK通用参数中的tenantId
	        this._commonParams.tenantId = this.tenantId;
	        this._commonParams.xsp_tenantid = this.tenantId;
	      }

	      // 如果是跨 BU 转交则 UserLeave MSG 将含有转交到的 tenantId，并且如果路由或路由版本有变更则替换本地的
	      if (this.departmentId !== departmentId) {
	        this.departmentId = departmentId;
	        //跨BU转交后，更新SDK通用参数中的tenantId
	        this._commonParams.xsp_departmentid = this.departmentId;
	      }

	      this.emit('UserSwitch', {
	        data: data,
	        type: 'leave',
	        message: '当前客服退出，正在转交至其他客服。'
	      });
	    } else {
	      try {
	        this.emit('UserLeave', {
	          data: data,
	          type: type,
	          message: msg
	        });
	      } catch (e) {}
	      this.destroy();
	    }
	  };

	  /**
	   * 获取历史消息
	   * @param data
	   * @returns {*}
	   */


	  OCS.prototype.getMessageLog = function getMessageLog(data) {
	    return this._request("historyMessage", (0, _assign2["default"])({ appName: this.appName }, data));
	  };

	  /**
	   * 获取历史消息（不反悔 totalItem ）
	   * @param data
	   * @returns {*}
	   */


	  OCS.prototype.getMessageLogByPage = function getMessageLogByPage(data) {
	    return this._request("historyMessageByPage", (0, _assign2["default"])({ appName: this.appName }, data));
	  };

	  /**
	   * 创建评价记录
	   *
	   */


	  OCS.prototype.createEvaluation = function createEvaluation(data) {
	    return this._request('createEvaluation', data);
	  };

	  /**
	   * 提交评价
	   *
	   */


	  OCS.prototype.submitEvaluation = function submitEvaluation(data) {
	    return this._request('submitEvaluation', data);
	  };

	  /**
	   * 退出排队
	   *
	   */


	  OCS.prototype.clearQueue = function clearQueue(data) {
	    return this._request('clearQueue', data, {
	      standard: false,
	      param: 'callbackName',
	      name: 'ClearQueueCallback'
	    });
	  };

	  /**
	   * 检查用户名
	   *
	   */


	  OCS.prototype.checkUserName = function checkUserName(data) {
	    return this._request('checkUserName', data, {
	      standard: false,
	      param: 'callbackName',
	      name: 'MinervaLoginCallback'
	    });
	  };

	  /**
	   * 老的评价接口
	   *
	   */


	  OCS.prototype.feedback = function feedback(data) {
	    return this._request('feedback', data, {
	      standard: false,
	      param: 'callbackName',
	      name: 'OcsFeedbackCallback'
	    });
	  };

	  /**
	   * 上传文件（图片）
	   *
	   */


	  OCS.prototype.uploadFile = function uploadFile(data) {
	    var formData = new FormData();
	    data = this._mergeCommonParams(data);
	    for (var k in data) {
	      formData.append(k, data[k]);
	    }

	    return fetch(this._getURL('uploadFile'), {
	      method: 'POST',
	      credentials: 'include',
	      body: formData
	    }).then(function (resp) {
	      return resp.json();
	    }, function (error) {
	      throw new Error('图片上传失败，请重试...');
	    });
	  };

	  /**
	   * 获取公告
	   *
	   */


	  OCS.prototype.getAnnouncement = function getAnnouncement(data) {
	    return this._request('getAnnouncement', data, {
	      standard: false,
	      param: 'callbackName',
	      name: 'OcsGetAnnouncementCallback'
	    });
	  };

	  /**
	   * 获取排队信息
	   *
	   */


	  OCS.prototype.getQueueInfo = function getQueueInfo(data) {
	    return this._request('getQueueInfo', data, {
	      standard: false,
	      param: 'callbackName',
	      name: 'OcsGetQueueInfoCallback'
	    });
	  };

	  /**
	   * 发送旺旺消息
	   *
	   */


	  OCS.prototype.sendWWMessage = function sendWWMessage(data) {
	    return this._request('sendWWMessage', data, {
	      standard: false,
	      param: 'callbackName',
	      name: 'OcsSendWWMessage'
	    });
	  };

	  /**
	   * 获取埋点配置详情（PC 会员端使用）
	   *
	   */


	  OCS.prototype.getSourceConfigDetail = function getSourceConfigDetail(data) {
	    return this._request('getSourceConfig', data, {
	      standard: false,
	      param: 'callbackName',
	      name: 'SourceIdConfigCallback'
	    });
	  };

	  OCS.prototype.getHotKnowledge = function getHotKnowledge(data) {
	    return this._request('getHotKnowledge', data, {
	      standard: false
	    });
	  };

	  OCS.prototype.getServiceStatus = function getServiceStatus(data) {
	    return this._request('getServiceStatus', data, {
	      standard: false
	    });
	  };

	  /**
	   * 销毁实例
	   */


	  OCS.prototype.destroy = function destroy() {
	    this._closeSession();
	    // 小蜜等端，在离线之后，可能会再次重新进线，且不重新实例化 SDK，
	    // 那么就不能删除所有的绑定事件。
	    //this.removeAllListeners();
	  };

	  return OCS;
	}(_im2["default"]);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	// This file can be required in Browserify and Node.js for automatic polyfill
	// To use it:  require('es6-promise/auto');
	'use strict';
	module.exports = __webpack_require__(2).polyfill();


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(process, global) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   4.1.1
	 */

	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ES6Promise = factory());
	}(this, (function () { 'use strict';

	function objectOrFunction(x) {
	  var type = typeof x;
	  return x !== null && (type === 'object' || type === 'function');
	}

	function isFunction(x) {
	  return typeof x === 'function';
	}

	var _isArray = undefined;
	if (Array.isArray) {
	  _isArray = Array.isArray;
	} else {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	}

	var isArray = _isArray;

	var len = 0;
	var vertxNext = undefined;
	var customSchedulerFn = undefined;

	var asap = function asap(callback, arg) {
	  queue[len] = callback;
	  queue[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 2, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    if (customSchedulerFn) {
	      customSchedulerFn(flush);
	    } else {
	      scheduleFlush();
	    }
	  }
	};

	function setScheduler(scheduleFn) {
	  customSchedulerFn = scheduleFn;
	}

	function setAsap(asapFn) {
	  asap = asapFn;
	}

	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

	// test for web worker but not in IE10
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

	// node
	function useNextTick() {
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // see https://github.com/cujojs/when/issues/410 for details
	  return function () {
	    return process.nextTick(flush);
	  };
	}

	// vertx
	function useVertxTimer() {
	  if (typeof vertxNext !== 'undefined') {
	    return function () {
	      vertxNext(flush);
	    };
	  }

	  return useSetTimeout();
	}

	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });

	  return function () {
	    node.data = iterations = ++iterations % 2;
	  };
	}

	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}

	function useSetTimeout() {
	  // Store setTimeout reference so es6-promise will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var globalSetTimeout = setTimeout;
	  return function () {
	    return globalSetTimeout(flush, 1);
	  };
	}

	var queue = new Array(1000);
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue[i];
	    var arg = queue[i + 1];

	    callback(arg);

	    queue[i] = undefined;
	    queue[i + 1] = undefined;
	  }

	  len = 0;
	}

	function attemptVertx() {
	  try {
	    var r = require;
	    var vertx = __webpack_require__(4);
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}

	var scheduleFlush = undefined;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush = useNextTick();
	} else if (BrowserMutationObserver) {
	  scheduleFlush = useMutationObserver();
	} else if (isWorker) {
	  scheduleFlush = useMessageChannel();
	} else if (browserWindow === undefined && "function" === 'function') {
	  scheduleFlush = attemptVertx();
	} else {
	  scheduleFlush = useSetTimeout();
	}

	function then(onFulfillment, onRejection) {
	  var _arguments = arguments;

	  var parent = this;

	  var child = new this.constructor(noop);

	  if (child[PROMISE_ID] === undefined) {
	    makePromise(child);
	  }

	  var _state = parent._state;

	  if (_state) {
	    (function () {
	      var callback = _arguments[_state - 1];
	      asap(function () {
	        return invokeCallback(_state, child, callback, parent._result);
	      });
	    })();
	  } else {
	    subscribe(parent, child, onFulfillment, onRejection);
	  }

	  return child;
	}

	/**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:

	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });

	  promise.then(function(value){
	    // value === 1
	  });
	  ```

	  Instead of writing the above, your code now simply becomes the following:

	  ```javascript
	  let promise = Promise.resolve(1);

	  promise.then(function(value){
	    // value === 1
	  });
	  ```

	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve$1(object) {
	  /*jshint validthis:true */
	  var Constructor = this;

	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }

	  var promise = new Constructor(noop);
	  resolve(promise, object);
	  return promise;
	}

	var PROMISE_ID = Math.random().toString(36).substring(16);

	function noop() {}

	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;

	var GET_THEN_ERROR = new ErrorObject();

	function selfFulfillment() {
	  return new TypeError("You cannot resolve a promise with itself");
	}

	function cannotReturnOwn() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}

	function getThen(promise) {
	  try {
	    return promise.then;
	  } catch (error) {
	    GET_THEN_ERROR.error = error;
	    return GET_THEN_ERROR;
	  }
	}

	function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then$$1.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}

	function handleForeignThenable(promise, thenable, then$$1) {
	  asap(function (promise) {
	    var sealed = false;
	    var error = tryThen(then$$1, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        resolve(promise, value);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;

	      reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));

	    if (!sealed && error) {
	      sealed = true;
	      reject(promise, error);
	    }
	  }, promise);
	}

	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      return resolve(promise, value);
	    }, function (reason) {
	      return reject(promise, reason);
	    });
	  }
	}

	function handleMaybeThenable(promise, maybeThenable, then$$1) {
	  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
	    handleOwnThenable(promise, maybeThenable);
	  } else {
	    if (then$$1 === GET_THEN_ERROR) {
	      reject(promise, GET_THEN_ERROR.error);
	      GET_THEN_ERROR.error = null;
	    } else if (then$$1 === undefined) {
	      fulfill(promise, maybeThenable);
	    } else if (isFunction(then$$1)) {
	      handleForeignThenable(promise, maybeThenable, then$$1);
	    } else {
	      fulfill(promise, maybeThenable);
	    }
	  }
	}

	function resolve(promise, value) {
	  if (promise === value) {
	    reject(promise, selfFulfillment());
	  } else if (objectOrFunction(value)) {
	    handleMaybeThenable(promise, value, getThen(value));
	  } else {
	    fulfill(promise, value);
	  }
	}

	function publishRejection(promise) {
	  if (promise._onerror) {
	    promise._onerror(promise._result);
	  }

	  publish(promise);
	}

	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }

	  promise._result = value;
	  promise._state = FULFILLED;

	  if (promise._subscribers.length !== 0) {
	    asap(publish, promise);
	  }
	}

	function reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;

	  asap(publishRejection, promise);
	}

	function subscribe(parent, child, onFulfillment, onRejection) {
	  var _subscribers = parent._subscribers;
	  var length = _subscribers.length;

	  parent._onerror = null;

	  _subscribers[length] = child;
	  _subscribers[length + FULFILLED] = onFulfillment;
	  _subscribers[length + REJECTED] = onRejection;

	  if (length === 0 && parent._state) {
	    asap(publish, parent);
	  }
	}

	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;

	  if (subscribers.length === 0) {
	    return;
	  }

	  var child = undefined,
	      callback = undefined,
	      detail = promise._result;

	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];

	    if (child) {
	      invokeCallback(settled, child, callback, detail);
	    } else {
	      callback(detail);
	    }
	  }

	  promise._subscribers.length = 0;
	}

	function ErrorObject() {
	  this.error = null;
	}

	var TRY_CATCH_ERROR = new ErrorObject();

	function tryCatch(callback, detail) {
	  try {
	    return callback(detail);
	  } catch (e) {
	    TRY_CATCH_ERROR.error = e;
	    return TRY_CATCH_ERROR;
	  }
	}

	function invokeCallback(settled, promise, callback, detail) {
	  var hasCallback = isFunction(callback),
	      value = undefined,
	      error = undefined,
	      succeeded = undefined,
	      failed = undefined;

	  if (hasCallback) {
	    value = tryCatch(callback, detail);

	    if (value === TRY_CATCH_ERROR) {
	      failed = true;
	      error = value.error;
	      value.error = null;
	    } else {
	      succeeded = true;
	    }

	    if (promise === value) {
	      reject(promise, cannotReturnOwn());
	      return;
	    }
	  } else {
	    value = detail;
	    succeeded = true;
	  }

	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && succeeded) {
	      resolve(promise, value);
	    } else if (failed) {
	      reject(promise, error);
	    } else if (settled === FULFILLED) {
	      fulfill(promise, value);
	    } else if (settled === REJECTED) {
	      reject(promise, value);
	    }
	}

	function initializePromise(promise, resolver) {
	  try {
	    resolver(function resolvePromise(value) {
	      resolve(promise, value);
	    }, function rejectPromise(reason) {
	      reject(promise, reason);
	    });
	  } catch (e) {
	    reject(promise, e);
	  }
	}

	var id = 0;
	function nextId() {
	  return id++;
	}

	function makePromise(promise) {
	  promise[PROMISE_ID] = id++;
	  promise._state = undefined;
	  promise._result = undefined;
	  promise._subscribers = [];
	}

	function Enumerator$1(Constructor, input) {
	  this._instanceConstructor = Constructor;
	  this.promise = new Constructor(noop);

	  if (!this.promise[PROMISE_ID]) {
	    makePromise(this.promise);
	  }

	  if (isArray(input)) {
	    this.length = input.length;
	    this._remaining = input.length;

	    this._result = new Array(this.length);

	    if (this.length === 0) {
	      fulfill(this.promise, this._result);
	    } else {
	      this.length = this.length || 0;
	      this._enumerate(input);
	      if (this._remaining === 0) {
	        fulfill(this.promise, this._result);
	      }
	    }
	  } else {
	    reject(this.promise, validationError());
	  }
	}

	function validationError() {
	  return new Error('Array Methods must be provided an Array');
	}

	Enumerator$1.prototype._enumerate = function (input) {
	  for (var i = 0; this._state === PENDING && i < input.length; i++) {
	    this._eachEntry(input[i], i);
	  }
	};

	Enumerator$1.prototype._eachEntry = function (entry, i) {
	  var c = this._instanceConstructor;
	  var resolve$$1 = c.resolve;

	  if (resolve$$1 === resolve$1) {
	    var _then = getThen(entry);

	    if (_then === then && entry._state !== PENDING) {
	      this._settledAt(entry._state, i, entry._result);
	    } else if (typeof _then !== 'function') {
	      this._remaining--;
	      this._result[i] = entry;
	    } else if (c === Promise$2) {
	      var promise = new c(noop);
	      handleMaybeThenable(promise, entry, _then);
	      this._willSettleAt(promise, i);
	    } else {
	      this._willSettleAt(new c(function (resolve$$1) {
	        return resolve$$1(entry);
	      }), i);
	    }
	  } else {
	    this._willSettleAt(resolve$$1(entry), i);
	  }
	};

	Enumerator$1.prototype._settledAt = function (state, i, value) {
	  var promise = this.promise;

	  if (promise._state === PENDING) {
	    this._remaining--;

	    if (state === REJECTED) {
	      reject(promise, value);
	    } else {
	      this._result[i] = value;
	    }
	  }

	  if (this._remaining === 0) {
	    fulfill(promise, this._result);
	  }
	};

	Enumerator$1.prototype._willSettleAt = function (promise, i) {
	  var enumerator = this;

	  subscribe(promise, undefined, function (value) {
	    return enumerator._settledAt(FULFILLED, i, value);
	  }, function (reason) {
	    return enumerator._settledAt(REJECTED, i, reason);
	  });
	};

	/**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.

	  Example:

	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];

	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```

	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:

	  Example:

	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];

	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```

	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all$1(entries) {
	  return new Enumerator$1(this, entries).promise;
	}

	/**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.

	  Example:

	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });

	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });

	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```

	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:

	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });

	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });

	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```

	  An example real-world use case is implementing timeouts:

	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```

	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race$1(entries) {
	  /*jshint validthis:true */
	  var Constructor = this;

	  if (!isArray(entries)) {
	    return new Constructor(function (_, reject) {
	      return reject(new TypeError('You must pass an array to race.'));
	    });
	  } else {
	    return new Constructor(function (resolve, reject) {
	      var length = entries.length;
	      for (var i = 0; i < length; i++) {
	        Constructor.resolve(entries[i]).then(resolve, reject);
	      }
	    });
	  }
	}

	/**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:

	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });

	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```

	  Instead of writing the above, your code now simply becomes the following:

	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));

	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```

	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject$1(reason) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop);
	  reject(promise, reason);
	  return promise;
	}

	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}

	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}

	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.

	  Terminology
	  -----------

	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.

	  A promise can be in one of three states: pending, fulfilled, or rejected.

	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.

	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.


	  Basic Usage:
	  ------------

	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);

	    // on failure
	    reject(reason);
	  });

	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```

	  Advanced Usage:
	  ---------------

	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.

	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();

	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();

	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }

	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```

	  Unlike callbacks, promises are great composable primitives.

	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON

	    return values;
	  });
	  ```

	  @class Promise
	  @param {function} resolver
	  Useful for tooling.
	  @constructor
	*/
	function Promise$2(resolver) {
	  this[PROMISE_ID] = nextId();
	  this._result = this._state = undefined;
	  this._subscribers = [];

	  if (noop !== resolver) {
	    typeof resolver !== 'function' && needsResolver();
	    this instanceof Promise$2 ? initializePromise(this, resolver) : needsNew();
	  }
	}

	Promise$2.all = all$1;
	Promise$2.race = race$1;
	Promise$2.resolve = resolve$1;
	Promise$2.reject = reject$1;
	Promise$2._setScheduler = setScheduler;
	Promise$2._setAsap = setAsap;
	Promise$2._asap = asap;

	Promise$2.prototype = {
	  constructor: Promise$2,

	  /**
	    The primary way of interacting with a promise is through its `then` method,
	    which registers callbacks to receive either a promise's eventual value or the
	    reason why the promise cannot be fulfilled.
	  
	    ```js
	    findUser().then(function(user){
	      // user is available
	    }, function(reason){
	      // user is unavailable, and you are given the reason why
	    });
	    ```
	  
	    Chaining
	    --------
	  
	    The return value of `then` is itself a promise.  This second, 'downstream'
	    promise is resolved with the return value of the first promise's fulfillment
	    or rejection handler, or rejected if the handler throws an exception.
	  
	    ```js
	    findUser().then(function (user) {
	      return user.name;
	    }, function (reason) {
	      return 'default name';
	    }).then(function (userName) {
	      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	      // will be `'default name'`
	    });
	  
	    findUser().then(function (user) {
	      throw new Error('Found user, but still unhappy');
	    }, function (reason) {
	      throw new Error('`findUser` rejected and we're unhappy');
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	    });
	    ```
	    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	  
	    ```js
	    findUser().then(function (user) {
	      throw new PedagogicalException('Upstream error');
	    }).then(function (value) {
	      // never reached
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // The `PedgagocialException` is propagated all the way down to here
	    });
	    ```
	  
	    Assimilation
	    ------------
	  
	    Sometimes the value you want to propagate to a downstream promise can only be
	    retrieved asynchronously. This can be achieved by returning a promise in the
	    fulfillment or rejection handler. The downstream promise will then be pending
	    until the returned promise is settled. This is called *assimilation*.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // The user's comments are now available
	    });
	    ```
	  
	    If the assimliated promise rejects, then the downstream promise will also reject.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // If `findCommentsByAuthor` fulfills, we'll have the value here
	    }, function (reason) {
	      // If `findCommentsByAuthor` rejects, we'll have the reason here
	    });
	    ```
	  
	    Simple Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let result;
	  
	    try {
	      result = findResult();
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	    findResult(function(result, err){
	      if (err) {
	        // failure
	      } else {
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findResult().then(function(result){
	      // success
	    }, function(reason){
	      // failure
	    });
	    ```
	  
	    Advanced Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let author, books;
	  
	    try {
	      author = findAuthor();
	      books  = findBooksByAuthor(author);
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	  
	    function foundBooks(books) {
	  
	    }
	  
	    function failure(reason) {
	  
	    }
	  
	    findAuthor(function(author, err){
	      if (err) {
	        failure(err);
	        // failure
	      } else {
	        try {
	          findBoooksByAuthor(author, function(books, err) {
	            if (err) {
	              failure(err);
	            } else {
	              try {
	                foundBooks(books);
	              } catch(reason) {
	                failure(reason);
	              }
	            }
	          });
	        } catch(error) {
	          failure(err);
	        }
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findAuthor().
	      then(findBooksByAuthor).
	      then(function(books){
	        // found books
	    }).catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method then
	    @param {Function} onFulfilled
	    @param {Function} onRejected
	    Useful for tooling.
	    @return {Promise}
	  */
	  then: then,

	  /**
	    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	    as the catch block of a try/catch statement.
	  
	    ```js
	    function findAuthor(){
	      throw new Error('couldn't find that author');
	    }
	  
	    // synchronous
	    try {
	      findAuthor();
	    } catch(reason) {
	      // something went wrong
	    }
	  
	    // async with promises
	    findAuthor().catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method catch
	    @param {Function} onRejection
	    Useful for tooling.
	    @return {Promise}
	  */
	  'catch': function _catch(onRejection) {
	    return this.then(null, onRejection);
	  }
	};

	/*global self*/
	function polyfill$1() {
	    var local = undefined;

	    if (typeof global !== 'undefined') {
	        local = global;
	    } else if (typeof self !== 'undefined') {
	        local = self;
	    } else {
	        try {
	            local = Function('return this')();
	        } catch (e) {
	            throw new Error('polyfill failed because global object is unavailable in this environment');
	        }
	    }

	    var P = local.Promise;

	    if (P) {
	        var promiseToString = null;
	        try {
	            promiseToString = Object.prototype.toString.call(P.resolve());
	        } catch (e) {
	            // silently ignored
	        }

	        if (promiseToString === '[object Promise]' && !P.cast) {
	            return;
	        }
	    }

	    local.Promise = Promise$2;
	}

	// Strange compat..
	Promise$2.polyfill = polyfill$1;
	Promise$2.Promise = Promise$2;

	return Promise$2;

	})));

	//# sourceMappingURL=es6-promise.map

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), (function() { return this; }())))

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};

	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.

	var cachedSetTimeout;
	var cachedClearTimeout;

	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }


	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }



	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;

	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}

	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;

	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}

	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};

	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};

	function noop() {}

	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;

	process.listeners = function (name) { return [] }

	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};

	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(6);
	module.exports = __webpack_require__(9).Object.assign;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(7);

	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(22) });


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var core = __webpack_require__(9);
	var ctx = __webpack_require__(10);
	var hide = __webpack_require__(12);
	var PROTOTYPE = 'prototype';

	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.0' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(11);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(13);
	var createDesc = __webpack_require__(21);
	module.exports = __webpack_require__(17) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(14);
	var IE8_DOM_DEFINE = __webpack_require__(16);
	var toPrimitive = __webpack_require__(20);
	var dP = Object.defineProperty;

	exports.f = __webpack_require__(17) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(15);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(17) && !__webpack_require__(18)(function () {
	  return Object.defineProperty(__webpack_require__(19)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(18)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(15);
	var document = __webpack_require__(8).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(15);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(23);
	var gOPS = __webpack_require__(38);
	var pIE = __webpack_require__(39);
	var toObject = __webpack_require__(40);
	var IObject = __webpack_require__(27);
	var $assign = Object.assign;

	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(18)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(24);
	var enumBugKeys = __webpack_require__(37);

	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(25);
	var toIObject = __webpack_require__(26);
	var arrayIndexOf = __webpack_require__(30)(false);
	var IE_PROTO = __webpack_require__(34)('IE_PROTO');

	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(27);
	var defined = __webpack_require__(29);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(28);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	var toString = {}.toString;

	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(26);
	var toLength = __webpack_require__(31);
	var toAbsoluteIndex = __webpack_require__(33);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(32);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(32);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(35)('keys');
	var uid = __webpack_require__(36);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(29);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';

	  if (self.fetch) {
	    return
	  }

	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }

	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]

	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }

	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }

	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }

	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }

	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }

	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }

	    return iterator
	  }

	  function Headers(headers) {
	    this.map = {}

	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)

	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }

	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }

	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }

	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }

	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }

	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }

	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }

	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }

	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }

	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }

	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }

	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }

	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }

	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }

	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }

	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }

	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)

	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }

	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }

	  function Body() {
	    this.bodyUsed = false

	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }

	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }

	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }

	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }

	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }

	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }

	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }

	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }

	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }

	    return this
	  }

	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }

	  function Request(input, options) {
	    options = options || {}
	    var body = options.body

	    if (typeof input === 'string') {
	      this.url = input
	    } else {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    }

	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null

	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }

	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }

	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }

	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split('\r\n').forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }

	  Body.call(Request.prototype)

	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }

	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }

	  Body.call(Response.prototype)

	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }

	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }

	  var redirectStatuses = [301, 302, 303, 307, 308]

	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }

	    return new Response(null, {status: status, headers: {location: url}})
	  }

	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response

	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()

	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }

	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }

	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }

	      xhr.open(request.method, request.url, true)

	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }

	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }

	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })

	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _events = __webpack_require__(43);

	var _events2 = _interopRequireDefault(_events);

	var _tarzanJsonp = __webpack_require__(44);

	var _tarzanJsonp2 = _interopRequireDefault(_tarzanJsonp);

	__webpack_require__(1);

	var _assign = __webpack_require__(5);

	var _assign2 = _interopRequireDefault(_assign);

	var _util = __webpack_require__(45);

	var _util2 = _interopRequireDefault(_util);

	var _const = __webpack_require__(46);

	var _const2 = _interopRequireDefault(_const);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Description: osp 和 ocs 的基类
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: 常胤 <satans17@gmail.com>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 15/3/30
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright(c) 2015 Taobao.com
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * http://moodpo.com/archives/jsdoc3-tutorial.html
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

	var LOOP_FOR_ROUTES_INTERVAL = 10 * 1000;
	var MAX_ROUTES_LOOP_TIME = 60 * 1000;

	/**
	 * IM SDK
	 *
	 * @class
	 */
	module.exports = function (_EventEmitter) {
	  _inherits(IM, _EventEmitter);

	  /**
	   * @description IM SDK constructor
	   * @constructor
	   * @param config
	   *  config.env: daily|prod
	   *  config.debug: true|false
	   *  config.sourceId
	   *  config.appName
	   *  config.token
	   */
	  function IM(config) {
	    _classCallCheck(this, IM);

	    /**
	     * 轮训实例
	     */
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

	    _this._loopInstance = null;

	    /**
	     * @desc 当前环境 日常|线上
	     * @type {string}
	     */
	    _this.env = config.env === 'prod' ? 'prod' : 'daily';

	    /**
	     * @desc 是否开启调试
	     * @type {boolean}
	     */
	    _this.debug = !!config.debug;

	    /**
	     * @desc 当前业务的SOURCEID，需要找云客服业务申请
	     * @type {string}
	     */
	    _this.sourceId = config.sourceId;

	    /**
	     * 区分业务
	     * @type {string}
	     */
	    _this.appName = config.appName;

	    /**
	     * token
	     */
	    _this.token = config.token;

	    /**
	     * 接口域名。
	     * 用于异地多活，当消息发送失败，则尝试不断获取新的路由规则，如路由有改变，则更新
	     * @type {object}
	     */
	    _this.defaultWebImDomain = 'webim';
	    _this.defaultConnectedDomain = 'connected';
	    _this.domain = {
	      harbor: '//webim.' + _const2["default"][_this.env],
	      connected: '//connected.' + _const2["default"][_this.env],
	      timestamp: -1
	    };

	    /**
	     * 是否开通消息必达功能，keepAlive 里会随时更新这个值
	     * 1: 开通，0: 关闭
	     */
	    _this._isDeliveredOn = config.delivered ? 1 : 0;

	    /**
	     * 收到的最近 10 条消息，用于消息必达的去重
	     *
	     */
	    _this._lastTenMsgIds = [];

	    /**
	     * 是否开通“已读未读”功能，keepAlive 里会随时更新这个值
	     * 1: 开通，0: 关闭
	     */
	    _this._isReadStatusOn = config.readStatus ? 1 : 0;

	    /**
	     * 用户类型
	     * 1=会员
	     * 2=客服
	     * @type {number}
	     */
	    _this.userType = config.userType;

	    /**
	     * 用户ID
	     * @type {string}
	     */
	    _this.userId = null;

	    /**
	     * 小二淘宝 ID
	     * @type {string}
	     */
	    _this.serviceUserId = config.serviceUserId;

	    /**
	     * 用户nick
	     * @type {string}
	     */
	    _this.userName = null;

	    /**
	     * tenantId，异地多活需要使用；目前是客服端在初始化的时候传入 tenantId，
	     * 会员端都需要调用 login 接口来获取
	     *
	     */
	    _this.tenantId = config.tenantId;

	    _this.departmentId = config.departmentId;

	    _this.routes = {};

	    /**
	     * @private 通用参数
	     * @type {object}
	     * @private
	     */
	    _this._commonParams = {
	      // 解决webx接收utf8编码的问题
	      "_input_charset": 'utf-8',
	      "tenantId": config.tenantId,
	      //支持xspace单元路由
	      "xsp_tenantid": config.tenantId,
	      "xsp_departmentid": config.departmentId,
	      "sourceId": config.sourceId,
	      "appName": config.appName,
	      "token": config.token,
	      "tokenVersion": config.tokenVersion,
	      "loginType": config.loginType,
	      "isMobile": config.isMobile

	      /**
	       * xcode 登录，必须同时提供这 4 个参数才可以。
	       * 如果传入 userId userName sourceId timetamp 但没传入 queueId 则将 isVisitor 设置为 true
	       */
	    };var xcode = config.xcode || {};
	    if (xcode.xcode && xcode.userId && xcode.userName && xcode.tt) {
	      var isVisitor = (xcode.sourceId || xcode.sourceid) && !xcode.queueId;
	      _this.userId = xcode.userId;
	      _this.userName = xcode.userName;

	      _this.addCommonParams((0, _assign2["default"])({
	        timestamp: xcode.tt,
	        isVisitor: isVisitor
	      }, config.xcode));
	    }

	    /**
	     * @private 记录上一次收消息时间
	     * @type {Date}
	     * @private
	     */
	    _this._loopTime = null;

	    /**
	     * @private 轮询定时器
	     * @type {null}
	     * @private
	     */
	    _this._loopTimer = null;

	    //支持配置监听事件
	    if (config.message && typeof config.message == 'function') {
	      _this.on('message', config.message);
	    }

	    return _this;
	  }

	  /**
	   * @method addCommonParams
	   * @desc 增加全局参数，所有的请求都会带上这些参数
	   * @param key {string} - 参数名
	   * @param value {string} - 参数值
	   * @example
	   * im.addCommonParams('sid','3784243029089789748');
	   * im.addCommonParams({'sid','4893274893278949848'})
	   */


	  IM.prototype.addCommonParams = function addCommonParams(key, value) {
	    if ((typeof key === 'undefined' ? 'undefined' : _typeof(key)) == 'object') {
	      for (var o in key) {
	        this._commonParams[o] = key[o];
	      }
	    } else if (typeof key == 'string') {
	      this._commonParams[key] = value;
	    }
	  };

	  /**
	   * @method getCommonParams
	   * @desc 获取公共配置
	   * @returns {object} - 返回全局参数
	   */


	  IM.prototype.getCommonParams = function getCommonParams() {
	    return this._commonParams;
	  };

	  /**
	   * @private 合并参数
	   * @param data
	   * @returns {Object}
	   * @private
	   */


	  IM.prototype._mergeCommonParams = function _mergeCommonParams() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	    return (0, _assign2["default"])({}, this._commonParams, data);
	  };

	  /**
	   * @method log
	   * @desc display debugger message
	   * @param msg {object} - 需要显示的debug信息
	   */


	  IM.prototype.log = function log(msg) {
	    if (this.debug) {
	      console.log(msg);
	    }
	  };

	  /**
	   * 获取对应接口的url地址
	   * @param name
	   * @returns {*}
	   */


	  IM.prototype._getURL = function _getURL(name) {
	    // 目前只有收发消息接口的应用是 connected
	    if (name === 'polling' || name === 'send' || name === 'ack') {
	      return this.domain['connected'] + _const2["default"].path[name];
	    }
	    return this.domain['harbor'] + _const2["default"].path[name];
	  };

	  /**
	   * 请求对应接口
	   * @param name 接口名称，在 const.js 中定义的
	   * @param data 请求的参数数据
	   * @param opts 请求的配置，timeout, standard 等
	   *
	   * @private
	   */


	  IM.prototype._request = function _request(name) {
	    var _this2 = this;

	    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	    var url = _util2["default"].param(this._getURL(name), this._mergeCommonParams(data));

	    return _util2["default"].request(url, opts).then(function (resp) {
	      return resp;
	    }, function (err) {
	      // 除了 reportHttpRequestIssue 之外，其他接口出错则在服务器记录此次错误, 正常业务接口返回的错误（含err.code)则不report
	      if (name !== 'reportHttpRequestIssue' && !err.code) {
	        _this2._request('reportHttpRequestIssue', {
	          requestUrl: _util2["default"].encode(url),
	          responseError: _util2["default"].encode(err && err.toString())
	        });
	      }
	      throw err;
	    });
	  };

	  /**
	   * @method start
	   * @desc 登录鉴权，客服端使用
	   * @example
	   * sdk.start({
	   *   userId: 111,
	   *   ...
	   * })
	   * .then(funciton(data){
	   *  alert('鉴权成功');
	   * },function(err){
	   *  alert('鉴权失败');
	   * })
	   *
	   */


	  IM.prototype.start = function start(config) {
	    var _this3 = this;

	    var login = config ? this._loginForConfig(config) : this._loginForInterface();

	    return login.then(function (data) {
	      _this3._loopStart();
	      _this3.emit('start', data);
	    }, function (err) {
	      throw err;
	    });
	  };

	  /**
	   * 从配置中获取鉴权信息
	   * @param config
	   * @private
	   */


	  IM.prototype._loginForConfig = function _loginForConfig(config) {
	    var _this4 = this;

	    return new Promise(function (resolve, reject) {
	      if (config.userId && config.userName && config.timestamp && config.xcode) {

	        //保存鉴权参数
	        _this4.addCommonParams({
	          xcode: config.xcode,
	          timestamp: config.timestamp
	        });

	        _this4.userId = config.userId;
	        _this4.userName = encodeURI(config.userName);

	        resolve(config);
	      } else {
	        reject(new Error('参数错误：userId,userName,sourceId,timestamp,xcode不能为空'));
	      }
	    });
	  };

	  /**
	   * 从接口中获取鉴权信息
	   * 淘宝业务适用
	   * @returns {*}
	   * @private
	   */


	  IM.prototype._loginForInterface = function _loginForInterface(opts) {
	    var _this5 = this;

	    var params = (0, _assign2["default"])({
	      requireTenantId: true
	    }, opts);

	    var handleLogin = function handleLogin(data) {

	      _this5.userId = data.userId;
	      _this5.userName = encodeURI(data.userName);
	      // “异地多活”需要
	      _this5.tenantId = data.tenantId;
	      _this5.departmentId = data.departmentId;
	      // 保存鉴权参数
	      // 此处将 userId 和 userName 都保存，是为了后续请求都带上此二参数；
	      // 目的是解决某些端在发请求的时候，没带上 cookie，导致接口获取 session 登录信息失败
	      _this5.addCommonParams({
	        userId: _this5.userId,
	        userName: _this5.userName,
	        xcode: data.xcode,
	        timestamp: data.tt,
	        tt: data.tt,
	        tenantId: _this5.tenantId,
	        xsp_tenantid: _this5.tenantId,
	        xsp_departmentid: _this5.departmentId
	      });

	      return data;
	    };

	    // 重试两次，login 接口在“规则链路”
	    return this._request('login', params).then(function (data) {
	      return handleLogin(data);
	    }, function (err) {
	      throw err;
	    });
	  };

	  /**
	   * 轮询获取新的路由
	   *
	   * @return Promise
	   */


	  IM.prototype._resend = function _resend(lastResendTime) {
	    var _this6 = this;

	    for (var _len = arguments.length, resendParams = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      resendParams[_key - 1] = arguments[_key];
	    }

	    return new Promise(function (resolve, reject) {
	      var func = function func() {
	        // 重新发送消息
	        resendParams.length && resolve(_this6.sendMessage.apply(_this6, resendParams.concat([false, lastResendTime])));
	      };

	      if (new Date() - lastResendTime >= MAX_ROUTES_LOOP_TIME) {
	        reject(new Error('Failed to send message after retrying...'));
	      } else {
	        //等待10s后再加载路由并重新发送消息
	        setTimeout(func, LOOP_FOR_ROUTES_INTERVAL);
	      }
	    });
	  };

	  /**
	   * 启动长连接轮询
	   * @private
	   */


	  IM.prototype._loopStart = function _loopStart() {
	    var _this7 = this;

	    this._loopTime = new Date();
	    // 如果检测超过一段时间没有收到消息，再强制再启动一次轮询
	    // @静无 说，此处超时时间为 60 秒
	    this._loopTimer = setInterval(function () {
	      if (new Date() - _this7._loopTime > 25000) {
	        _this7._loop();
	      }
	    }, 25500);

	    this._loop();
	  };

	  /**
	   * 长连接轮询
	   * @private
	   */


	  IM.prototype._loop = function _loop() {
	    var _this8 = this;

	    var url = _util2["default"].param(this._getURL('polling'), this._mergeCommonParams({
	      senderId: this.userId,
	      senderName: this.userName,
	      sourceId: this.sourceId,
	      rtt: this.domain.timestamp, // 添加路由版本号
	      delivered: this._isDeliveredOn // 表明开通“消息必达”功能
	    }));

	    // 取消其他轮询实例，不然会重复发送请求。
	    // 极端情况下这么做会丢消息，但是由于没有消息状态，暂时没有更好的办法。
	    this._cancelLoop();

	    this._loopInstance = (0, _tarzanJsonp2["default"])(url, {
	      // 长连接超时时间20s
	      timeout: 23000,
	      charset: 'utf-8'
	    }, function (err, response) {

	      if (err || !response) {
	        if (err && !err.code) {
	          // 在服务器记录出错信息，正常的业务接口的错误(含err.code)则不report
	          _this8._request('reportHttpRequestIssue', {
	            requestUrl: _util2["default"].encode(url),
	            responseError: _util2["default"].encode(err && err.toString())
	          });
	        }

	        // 即使返回错误的结果，也需要再重新发送轮询
	        _this8._startNewLoop();
	      } else {

	        if (response !== undefined && Object.prototype.toString.call(response) !== '[object Array]') {
	          // 如果不是数组，记录一下，便于排查问题
	          if (window.tracker) {
	            window.tracker.log({
	              code: 19,
	              msg: 'ocs message receives wrong data',
	              c1: JSON.stringify(response),
	              c2: url
	            });
	          }
	          // 然后强制改为空数组
	          response = [];
	        }

	        // 去重
	        var msgList = _this8._removeDuplicateMsg(response);
	        var mids = msgList.map(function (item) {
	          return (item.head || {}).mid;
	        });
	        if (!mids.length) return _this8._startNewLoop();

	        // 更新最近的 10 条消息
	        _this8._storeNewestMsg(mids);

	        // 推送消息
	        _this8.emit('message', msgList);

	        // 没开通必达，则重新开始 loop 即可，不必再发 ack
	        if (!_this8._isDeliveredOn) return _this8._startNewLoop();

	        // 过滤需要发送 ack 的消息类型
	        var midsShouldAck = msgList.filter(function (item) {
	          return !~['TypingStart', 'TypingEnd', 'PreMSG', 'Queue'].indexOf(item.cmd);
	        }).map(function (item) {
	          return (item.head || {}).mid;
	        });

	        if (!midsShouldAck.length) return _this8._startNewLoop();

	        // 发送 ack 请求
	        _this8._ack({
	          mids: midsShouldAck
	        }).then(function (data) {
	          _this8._startNewLoop();
	        }, function (err) {
	          _this8._startNewLoop();
	        });
	      }
	    });
	  };

	  /**
	   * 开始新的 loop，如果小二状态允许
	   *
	   */


	  IM.prototype._startNewLoop = function _startNewLoop() {
	    // 如果已经 close 了，则不再重新轮询了
	    if (!this._loopTimer) return;
	    this._loopTime = new Date();
	    this._loop();
	  };

	  /**
	   * 消息必达的 ack 请求，当收到消息后，告诉服务器已经收到
	   *
	   * @param mids {Array}  消息 id 数组
	   *
	   */


	  IM.prototype._ack = function _ack() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        mids = _ref.mids;

	    return this._request('ack', {
	      senderId: this.userId,
	      senderName: this.userName,
	      mids: mids
	    }, {
	      timeout: 3000
	    });
	  };

	  /**
	   * 消息必达开通后，删去有可能收到的重复消息，返回一个新数组
	   *
	   * @param msgList {Array} loop 收到的消息数组
	   *
	   * @return {Array}
	   */


	  IM.prototype._removeDuplicateMsg = function _removeDuplicateMsg() {
	    var _this9 = this;

	    var msgList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	    return msgList.filter(function (item) {
	      var _ref2 = item.head || {},
	          mid = _ref2.mid;

	      return !~_this9._lastTenMsgIds.indexOf(mid);
	    });
	  };

	  /**
	   * 保存最近的 10 条消息 ID
	   *
	   * @param msgIds {Array} 去重后的消息数组 ID
	   *
	   */


	  IM.prototype._storeNewestMsg = function _storeNewestMsg(msgIds) {
	    var newList = this._lastTenMsgIds.concat(msgIds);
	    var len = newList.length;
	    this._lastTenMsgIds = len > 10 ? newList.slice(len - 10) : newList;
	  };

	  /**
	   * 停止轮询
	   * @private
	   */


	  IM.prototype._cancelLoop = function _cancelLoop() {
	    if (this._loopInstance && typeof this._loopInstance == 'function') {
	      this._loopInstance();
	    }
	  };

	  /**
	   * @method close
	   * @desc 关闭会话
	   * @example
	   * sdk.close();
	   *
	   */


	  IM.prototype.close = function close() {
	    //停止轮询
	    this._cancelLoop();
	    //停止防断检测
	    if (this._loopTimer) {
	      clearInterval(this._loopTimer);
	      this._loopTimer = null;
	    }
	  };

	  return IM;
	}(_events2["default"]);

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;

	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;

	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;

	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;

	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};

	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;

	  if (!this._events)
	    this._events = {};

	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }

	  handler = this._events[type];

	  if (isUndefined(handler))
	    return false;

	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }

	  return true;
	};

	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;

	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');

	  if (!this._events)
	    this._events = {};

	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);

	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];

	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }

	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }

	  return this;
	};

	EventEmitter.prototype.on = EventEmitter.prototype.addListener;

	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');

	  var fired = false;

	  function g() {
	    this.removeListener(type, g);

	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }

	  g.listener = listener;
	  this.on(type, g);

	  return this;
	};

	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;

	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');

	  if (!this._events || !this._events[type])
	    return this;

	  list = this._events[type];
	  length = list.length;
	  position = -1;

	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);

	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }

	    if (position < 0)
	      return this;

	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }

	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }

	  return this;
	};

	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;

	  if (!this._events)
	    return this;

	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }

	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }

	  listeners = this._events[type];

	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];

	  return this;
	};

	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};

	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];

	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};

	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};

	function isFunction(arg) {
	  return typeof arg === 'function';
	}

	function isNumber(arg) {
	  return typeof arg === 'number';
	}

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}

	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	/**
	 * Module dependencies
	 */

	// var debug = require('debug')('jsonp');
	function debug(){
	  //
	}

	/**
	 * Module exports.
	 */

	module.exports = jsonp;

	/**
	 * Callback index.
	 */

	var count = 0;

	/**
	 * Noop function.
	 */

	function noop(){}

	/**
	 * JSONP handler
	 *
	 * Options:
	 *  - param {String} qs parameter (`callback`)
	 *  - prefix {String} qs parameter (`__jp`)
	 *  - name {String} qs parameter (`prefix` + incr)
	 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
	 *
	 * @param {String} url
	 * @param {Object|Function} optional options / callback
	 * @param {Function} optional callback
	 */

	function jsonp(url, opts, fn){
	  if ('function' == typeof opts) {
	    fn = opts;
	    opts = {};
	  }
	  if (!opts) opts = {};

	  var prefix = opts.prefix || '__jp';

	  // use the callback name that was passed if one was provided.
	  // otherwise generate a unique name by incrementing our counter.
	  var id = opts.name || (prefix + Date.now() + (count++));

	  var charset = opts.charset || 'utf-8';
	  var param = opts.param || 'callback';
	  var timeout = null != opts.timeout ? opts.timeout : 60000;
	  var enc = encodeURIComponent;
	  var target = document.getElementsByTagName('script')[0] || document.head;
	  var script;
	  var timer;


	  if (timeout) {
	    timer = setTimeout(function(){
	      cleanup();
	      if (fn) fn(new Error('Timeout'));
	    }, timeout);
	  }

	  function cleanup(){
	    if (script.parentNode) script.parentNode.removeChild(script);
	    window[id] = noop;
	    if (timer) clearTimeout(timer);
	  }

	  function cancel(){
	    if (window[id]) {
	      cleanup();
	    }
	  }

	  
	  window[id] = function(data){
	    debug('jsonp got', data);
	    cleanup();
	    if (fn) fn(null, data);
	  };

	  // add qs component
	  // TB CDN comnine like: http://g.alicdn.com/tarzan/tarzan-jsbridge/0.3.5/client/taobao/??index-min.js?callback=JSBridgePlugin
	  url += (url.replace(/\?\?/g,"").indexOf("?")>-1) ? '&' : '?';
	  //url += `${param}=${enc(id)}&v=${+new Date()}`;
	  url += param + '=' + enc(id) + '&v=' + (+new Date());
	  url = url.replace('?&', '?');

	  debug('jsonp req "%s"', url);
	  // create script
	  script = document.createElement('script');
	  script.src = url;
	  script.charset = charset;
	  target.parentNode.insertBefore(script, target);

	  return cancel;
	}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(1);

	var _tarzanJsonp = __webpack_require__(44);

	var _tarzanJsonp2 = _interopRequireDefault(_tarzanJsonp);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

	/**
	 * Description: utilities
	 * User: 常胤 <satans17@gmail.com>
	 * Date: 15/3/30
	 * Copyright(c) 2014 Taobao.com
	 */

	function request(url) {
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	  var opts = {
	    timeout: 30 * 1000,
	    charset: 'utf-8'
	  };

	  if (config.timeout) opts.timeout = config.timeout;
	  if (config.param) opts.param = config.param;
	  if (config.name) opts.name = config.name;

	  return new Promise(function (resolve, reject) {

	    // 这里的 timeout 改为 30 秒，便于异地多活切路由时，更早收到消息发送失败的错误
	    (0, _tarzanJsonp2["default"])(url, opts, function (err, response) {

	      //非标准格式
	      if (config.standard === false) {
	        if (err) {
	          reject(err);
	        } else {
	          resolve(response);
	        }
	      }
	      // 标准格式 standard:
	      //    callback({status:1,data:{}});
	      //    callback({status:0,data: {message:'', code:''}});
	      // SOP新 sop submit:
	      //    callback({success:true,data:{}});
	      //    callback({success:false,data:{errMsg:'', errCode:''}});
	      else {
	          if (!err && !response) {
	            err = new Error('response data is null');
	          }

	          if (response && (response.status == 0 || response.success === false)) {
	            err = new Error(response.message || response.errMsg);
	            err.code = response.code || response.errCode;
	          }

	          if (err) {
	            reject(err);
	          } else {
	            resolve(response.data);
	          }
	        }
	    });
	  });
	}

	function param(url, d) {
	  var t = [];

	  var _loop = function _loop(o) {
	    var e = d[o];
	    if (d.hasOwnProperty(o) && typeof e !== 'undefined') {
	      if (Object.prototype.toString.call(e) === '[object Array]') {
	        e.forEach(function (item) {
	          return t.push(o + '=' + item);
	        });
	      } else if (Object.prototype.toString.call(e) !== '[object Object]') {
	        t.push(o + '=' + e);
	      }
	    }
	  };

	  for (var o in d) {
	    _loop(o);
	  }
	  return url + (~url.indexOf('?') ? '&' : '?') + t.join('&');
	}

	function encode(str) {
	  return encodeURIComponent(str);
	}

	module.exports = {
	  request: request,
	  param: param,
	  encode: encode
	};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';

	/**
	 * Description: 常量
	 * User: 常胤 <satans17@gmail.com>
	 * Date: 15/5/21
	 * Copyright(c) 2015 Taobao.com
	 */

	module.exports = {
	  daily: 'daily.taobao.net',
	  prod: 'taobao.com',
	  path: {
	    login: '/auth/login.do',
	    send: '/webim/message/send',
	    ack: '/webim/message/ack',
	    dispatch: '/ocs/Dispatch.do',
	    polling: '/webim/messages',
	    resume: '/ocs/ResumeSession.do',
	    keepAlive: '/ocs/KeepAlive.do',
	    getQueueNumber: '/ocs/GetSkillGroupQueueWaitingNumber.do',
	    checkOcsSource: '/ocs/CheckOcsSource.do',
	    getOcsQueueNotice: '/ocs/GetOcsQueueNotice.do',
	    getSourceIdConfigDetail: '/ocs/GetSourceConfigById.do',
	    memberLeave: '/ocs/MemberLeave.do',
	    historyMessage: '/im/GetMessageLog.do',
	    historyMessageByPage: '/im/GetMessageLogByPage.do',
	    createEvaluation: '/support/onlinecs/sdk/ocs/createEvaluation.do',
	    submitEvaluation: '/support/onlinecs/sdk/ocs/submitEvaluation.do',
	    reportHttpRequestIssue: '/report/reportHttpRequestIssue.do',

	    // for OSP（客服端）
	    words: '/support/onlinecs/AjaxWordsLanguages.do',
	    sendFileMessage: '/support/onlinecs/SendFileMessageJson.do',
	    sendTextMessage: '/support/onlinecs/send_text_message.do',
	    servicerLeave: '/support/onlinecs/ServicerLeave.do',
	    servicerChangeStatus: '/support/onlinecs/servicerChangeStatus.do',
	    workInfo: '/support/onlinecs/ServicerWorksetInfo.do',
	    specialWorkInfo: '/support/onlinecs/SpecialityStatus.do',
	    submitSpecialty: '/support/onlinecs/SubmitUseSpeciality.do',
	    switchQueue: '/support/onlinecs/switchQueue.do',
	    servicerKeepAlive: '/support/onlinecs/keep_alive.do',
	    onlineAjaxWorkStatus: '/support/onlinecs/OnlineAjaxWorkStatus.do',
	    messageLog: '/support/onlinecs/getMessageLogBySid.do',
	    messageLogAlicare: '/im/GetMessageLogForServicer.do',
	    getOcsSessionUserByServicerId: '/support/onlinecs/getOcsSessionUsersByServicerId.do',
	    searchOcsSessionUsersByInfo: '/support/onlinecs/searchOcsSessionUsersByInfo.do',
	    anywatcherCheckMessage: '/anywatcher/AnyWatcherCheckAndGetDetail.do',
	    anywatcherSaveMessage: '/anywatcher/AnyWatcherSaveMessage.do',
	    urlSafetyCheck: '/im/MsgSecurityCheck.do',
	    recordViewFullName: '/ocs/SaveOperatorLogBySid.do',
	    tokenCode: '/auth/GetTokenCode.do',
	    p2pAcceptJoin: '/p2p/AcceptP2PDispatch.do',
	    p2pDenyJoin: '/p2p/RejectP2PDispatch.do',
	    ocsSystemMessage: '/support/onlinecs/sdk/CsSendSystemMessage.do',
	    syncUsers: '/support/onlinecs/AjaxGetUserJoinInfo.do',
	    revertMessage: '/im/RevertMessage.do',
	    deleteMessage: '/im/DeleteMessageLog.do',

	    // for OCS（会员端）
	    clearQueue: '/support/onlinecs/sdk/CsClearQueue.do',
	    checkUserName: '/support/minerva/sdk/minerva_login.do',
	    feedback: '/support/onlinecs/sdk/CsFeedback.do',
	    uploadFile: '/support/onlinecs/sdk/cs_post_file_message.do',
	    getAnnouncement: '/support/onlinecs/sdk/ocsReceiveNotice.do',
	    getQueueInfo: '/support/onlinecs/sdk/csQueueInfo.do',
	    sendWWMessage: '/support/onlinecs/sdk/csSendWWMessage.do',
	    getSourceConfig: '/support/sdk/sourceIdConfigDetail.do',
	    getServiceStatus: '/support/onlinecs/sdk/cs_service_status.do',
	    getHotKnowledge: '/support/onlinecs/ocs/hotKnowledge.do'
	  }
	};

/***/ })
/******/ ])
});
;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_tarzan-ocs@5.5.1@@ali/tarzan-ocs/build/ocs.js
// module id = 21
// module chunks = 2